import editSVG from '../../assets/svgs/Edit.svg';

import classes from './Trow.module.scss';

export default function Trow({
  Raw,
  Username,
  Company,
  Address,
  AccessLevel,
  leftStyle = null,
  rightStyle = null,
  Edit = true,
}) {
  return (
    <tr className={classes.row}>
      <td style={leftStyle}>{Raw}</td>
      <td>{Username}</td>
      <td>{Company}</td>
      <td>{Address}</td>
      <td>{AccessLevel}</td>
      <td style={rightStyle}>
        <img src={editSVG} alt="" />
      </td>
    </tr>
  );
}
